import { AuthenticatedDataRequest } from '@eggplant/data-request'
import { type ReactElement } from 'react'
import { SUT_SERVICE } from '@eggplant/api-hosts'
import type { Error } from '@eggplant/types'

interface Props {
  onError?: (error: Error) => void
  onSuccess?: (response: string[]) => void
  children?: (response: string[]) => ReactElement
  shortErrorMessage?: string
  dataCenter: string
}

const GetSauceLabsPlatforms = ({
  shortErrorMessage,
  onError,
  onSuccess,
  children,
  dataCenter
}: Props) => {
  const url = `${SUT_SERVICE}/sauce_labs/data_centers/${dataCenter}/browser_platforms`

  return (
    <AuthenticatedDataRequest
      children={children}
      method='get'
      onError={onError}
      onSuccess={onSuccess}
      shortErrorMessage={shortErrorMessage}
      url={url}
    />
  )
}

export default GetSauceLabsPlatforms
